// Auto-generated by scripts/build-blog.ts — do not edit
import type { BlogPostMeta } from '@/types/blog'

export const blogPosts: BlogPostMeta[] = [
  {
    "title": "Composing Sightmap and Sightkick: Building in Layers",
    "excerpt": "Sightkick gives agents a clean tool interface to drive web apps live, which is ideal for co-browsing and troubleshooting. CI needs the opposite: sub-second speed, zero non-determinism, zero token cost. So agents author and resolve the plans upfront instead. Three layers: a map, a toolbox, and a spec.",
    "topic": "research",
    "date": "2026-09-22",
    "author": "Clint Ayres",
    "slug": "building-in-layers",
    "image": "/blog/og/building-in-layers.png",
    "readingTime": 5
  },
  {
    "title": "Giving web apps a real callable surface (instead of making AI guess your DOM)",
    "excerpt": "Browser agents burn tens of thousands of tokens guessing which div is the submit button, then fall apart when someone renames a Tailwind class. Sightkick compiles a declared tool layer into typed WebMCP tools on document.modelContext, so the agent makes a function call and gets a clean result. Here's what we learned building it.",
    "topic": "research",
    "date": "2026-09-08",
    "author": "Clint Ayres",
    "slug": "sightkick",
    "image": "/blog/og/sightkick.png",
    "readingTime": 7
  },
  {
    "title": "Sightmap: the runtime map of your app",
    "excerpt": "A sightmap gives every view, component, and API request in your app a semantic name, so your agent sees meaning instead of DOM noise and carries forward the instructions for how to operate your app.",
    "topic": "research",
    "date": "2026-07-29",
    "author": "Clint Ayres",
    "slug": "sightmap",
    "image": "/blog/og/sightmap.png",
    "readingTime": 7
  }
]
